/**
 * Admin module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Admin pages
const PermissionsPage = lazyWithRetry(() => import('@/features/admin/pages/PermissionsPage'));
const AuditLogsPage = lazyWithRetry(() => import('@/features/admin/pages/AuditLogsPage'));
const LegalDocumentsPage = lazyWithRetry(() => import('@/features/admin/pages/LegalDocumentsPage'));
const DocumentSettingsPage = lazyWithRetry(() => import('@/features/admin/pages/DocumentSettingsPage'));
const TableConfigPage = lazyWithRetry(() => import('@/features/admin/pages/TableConfigPage'));
const EmailGatewayPage = lazyWithRetry(() => import('@/features/admin/pages/EmailGatewayPage'));
const OneCExchangePage = lazyWithRetry(() => import('@/features/integration1c/pages/OneCExchangePage'));

export const adminRoutes: RouteObject[] = [
      // --------------------------------
      // Admin Module (Administrator/SuperAdmin only)
      // --------------------------------
      {
        path: ROUTES.admin.permissions,
        element: (
          <PermissionRoute permission={PK.Permissions.MatrixView}>
            <PermissionsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.admin.auditLogs,
        element: (
          <PermissionRoute permission={PK.AuditLogs.View}>
            <AuditLogsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.admin.legalDocuments,
        element: (
          <PermissionRoute permission={PK.Legal.Manage}>
            <LegalDocumentsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.admin.documentSettings,
        element: (
          <PermissionRoute permission={PK.Settings.Manage}>
            <DocumentSettingsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.admin.tableConfig,
        element: (
          <PermissionRoute permission={PK.Tables.ConfigView}>
            <TableConfigPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.admin.emailGateway,
        element: (
          <PermissionRoute permission={PK.EmailGateway.View}>
            <EmailGatewayPage />
          </PermissionRoute>
        ),
      },
      {
        // TOSS ↔ 1C: the server gates every /api/lk/integrations/1c/* route by settings.manage.
        path: ROUTES.admin.integration1c,
        element: (
          <PermissionRoute permission={PK.Settings.Manage}>
            <OneCExchangePage />
          </PermissionRoute>
        ),
      },
];
